export default __webpack_public_path__ + "static/maremailcase1-0b8f9d2a8fe5e516e35cfcdbdf894a67.png";